export const isJapanCountry = (countryId?: string | null): boolean => countryId === 'JP';
export const isThailandCountry = (countryId?: string | null): boolean => countryId === 'TH';
export const isIndonesiaCountry = (countryId?: string | null): boolean => countryId === 'ID';
